/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadExchangeDestination } from './LeadExchangeDestination';
import {
    LeadExchangeDestinationFromJSON,
    LeadExchangeDestinationFromJSONTyped,
    LeadExchangeDestinationToJSON,
} from './LeadExchangeDestination';

/**
 * 
 * @export
 * @interface GetLeadExchangeDestinationsResponseData
 */
export interface GetLeadExchangeDestinationsResponseData {
    /**
     * 
     * @type {string}
     * @memberof GetLeadExchangeDestinationsResponseData
     */
    state: GetLeadExchangeDestinationsResponseDataStateEnum;
    /**
     * 
     * @type {Array<LeadExchangeDestination>}
     * @memberof GetLeadExchangeDestinationsResponseData
     */
    facilities: Array<LeadExchangeDestination>;
}


/**
 * @export
 */
export const GetLeadExchangeDestinationsResponseDataStateEnum = {
    Disabled: 'disabled',
    NoDestinations: 'no_destinations',
    Available: 'available'
} as const;
export type GetLeadExchangeDestinationsResponseDataStateEnum = typeof GetLeadExchangeDestinationsResponseDataStateEnum[keyof typeof GetLeadExchangeDestinationsResponseDataStateEnum];


/**
 * Check if a given object implements the GetLeadExchangeDestinationsResponseData interface.
 */
export function instanceOfGetLeadExchangeDestinationsResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "facilities" in value;

    return isInstance;
}

export function GetLeadExchangeDestinationsResponseDataFromJSON(json: any): GetLeadExchangeDestinationsResponseData {
    return GetLeadExchangeDestinationsResponseDataFromJSONTyped(json, false);
}

export function GetLeadExchangeDestinationsResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadExchangeDestinationsResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': json['state'],
        'facilities': ((json['facilities'] as Array<any>).map(LeadExchangeDestinationFromJSON)),
    };
}

export function GetLeadExchangeDestinationsResponseDataToJSON(value?: GetLeadExchangeDestinationsResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': value.state,
        'facilities': ((value.facilities as Array<any>).map(LeadExchangeDestinationToJSON)),
    };
}

